import { AvailableTags } from '../Tags';

// Create Map to allow access by lower case
const TagMap: Record<string, string> = AvailableTags
  .reduce((map, tagData) => ({
    ...map,
    [tagData.label.toLowerCase().replace(/\s/gu, '')]: tagData.label,
  }), {});

export class TagService {
  public static deepGet (obj: Record<string, unknown>, path: string): unknown {
    return path.split('.')
      .reduce((bag, pathPart) => {
        return typeof bag === 'object' && bag !== null && bag[pathPart] !== undefined
          ? bag[pathPart] as unknown as Record<string, unknown>
          : undefined as unknown as Record<string, unknown>;
      }, obj);
  }

  public static detectTags (text: string): string[] {
    const tagDetectRegex = /\[[\w\s]*\]/gui;
    const matches = text.match(tagDetectRegex);
    if (!Array.isArray(matches) || matches.length === 0) {
      return [];
    }
    // Remove duplicate with set - remove bracket with slice
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return [...new Set(matches)].map((tag) => tag.slice(1, -1));
  }

  public static replaceTags (text: string, data:Record<string, unknown>): string {
    // Do not alter param
    let textWithTags = text.concat('');
    const usedTags = this.detectTags(text);
    for (const tagName of usedTags) {
      const tagKey = tagName.toLowerCase().replace(/\s/gu, '');
      const tagMatch = TagMap[tagKey];
      let value = '';
      if (tagMatch !== undefined) {
        const tagDefinition = AvailableTags.find((tagData) => tagData.label === tagMatch);
        if (tagDefinition !== undefined) {
          value = this.deepGet(data, tagDefinition.tag.map) as string;
          if (value === undefined || value === null) {
            value = '';
          }
        }
      }
      // Add bracket surrounding tag use
      textWithTags = textWithTags.replace(new RegExp(`\\[${tagName}\\]`, 'giu'), value);
    }
    return textWithTags;
  }
}
